<template>
  <div class="psvto-page">
    <div class="psvto-header">
      <Skeleton width="204px" height="20px" borderRadius="4px" />
    </div>

    <div class="psvto-subHeader">
      <div class="psvto-subHeader-first">
        <Skeleton width="225px" height="42px" borderRadius="4px" />
        <Skeleton width="306px" height="42px" borderRadius="4px" />
      </div>
      <Skeleton width="986px" height="64px" borderRadius="4px" />
    </div>

    <div class="psvto-wrapper">
      <div class="psvto-table">
        <div class="psvto-row psvto-row--head">
          <div class="psvto-left2 psvto-left2--head">
            <div class="psvto-cell psvto-c1 psvto-c1--head">
              <Skeleton width="20px" height="20px" borderRadius="4px" />
            </div>

            <div class="psvto-cell psvto-c2 psvto-c2--head">
              <Skeleton width="100px" height="18px" borderRadius="4px" />
            </div>
          </div>

          <div class="psvto-rest psvto-rest--head">
            <div class="psvto-cell psvto-c3 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c4 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c5 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c6 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>

            <div class="psvto-cell psvto-c7 psvto-c7--head">
              <div class="psvto-c7-headInner">
                <Skeleton width="70px" height="18px" borderRadius="4px" />
                <Skeleton width="20px" height="20px" borderRadius="16px" />
              </div>
            </div>

            <div class="psvto-cell psvto-c8 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c9 psvto-headCell">
              <Skeleton width="70px" height="18px" borderRadius="4px" />
            </div>
          </div>
        </div>

        <div v-for="r in bodyRows" :key="r" class="psvto-row psvto-row--body">
          <div class="psvto-left2 psvto-left2--body">
            <div class="psvto-cell psvto-c1 psvto-c1--body">
              <Skeleton width="20px" height="20px" borderRadius="4px" />
            </div>

            <div class="psvto-cell psvto-c2 psvto-c2--body">
              <Skeleton width="116px" height="36px" borderRadius="4px" />
            </div>
          </div>

          <div class="psvto-rest psvto-rest--body">
            <div class="psvto-cell psvto-c3 psvto-bodyCell">
              <Skeleton width="82px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c4 psvto-bodyCell">
              <Skeleton width="82px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c5 psvto-bodyCell">
              <Skeleton width="82px" height="18px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c6 psvto-bodyCell">
              <Skeleton width="117px" height="18px" borderRadius="4px" />
            </div>

            <div class="psvto-cell psvto-c7 psvto-c7--body">
              <Skeleton width="122px" height="40px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c8 psvto-c8--body">
              <Skeleton width="122px" height="40px" borderRadius="4px" />
            </div>
            <div class="psvto-cell psvto-c9 psvto-c9--body">
              <Skeleton width="122px" height="40px" borderRadius="4px" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="psvto-footer">
      <Skeleton width="148px" height="40px" borderRadius="4px" />
      <Skeleton width="148px" height="40px" borderRadius="4px" />
    </div>

    <div class="psvto-subFooter-container">
      <div class="psvto-subFooter-container-sub">
        <div class="psvto-subFooter-container-sub-left">
          <Skeleton width="32px" height="32px" borderRadius="4px" />
          <Skeleton width="32px" height="32px" borderRadius="4px" />
          <Skeleton width="176px" height="32px" borderRadius="4px" />
          <Skeleton width="32px" height="32px" borderRadius="4px" />
          <Skeleton width="32px" height="32px" borderRadius="4px" />
        </div>
        <Skeleton width="173px" height="42px" borderRadius="4px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';

const bodyRows = Array.from({ length: 20 }, (_, i) => i + 1);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.psvto-page {
  width: 100%;
  background-color: $colorN00;
  padding-bottom: 24px;
  border-radius: 8px;
}

.psvto-header {
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

.psvto-subHeader {
  display: flex;
  padding: 16px 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  &-first {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

.psvto-wrapper {
  display: flex;
  padding: 0 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.psvto-table {
  display: flex;
  width: 986px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid $colorN50;
  overflow: hidden;
}

.psvto-row {
  display: flex;
  width: 100%;
  align-items: stretch;
  position: relative;
}

.psvto-row--head::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.5px;
  background: $colorN30;
  pointer-events: none;
}
.psvto-row--head::after {
  content: '';
  position: absolute;
  left: 184px;
  right: 0;
  bottom: 0;
  height: 4px;
  background: $colorN30;
  pointer-events: none;
}

.psvto-row--body::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.5px;
  background: $colorN30;
  pointer-events: none;
}

.psvto-left2--head {
  display: flex;
  align-items: flex-start;
  border-right: 1px solid $colorN50;
}

.psvto-left2--body {
  display: flex;
  height: 72px;
  align-items: flex-start;
  border-right: 1px solid $colorN50;
}

.psvto-rest--head {
  display: flex;
  align-items: center;
  flex: 1 0 0;
}

.psvto-rest--body {
  display: flex;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
}

.psvto-cell {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.psvto-c1--head {
  display: flex;
  height: 50px;
  padding: 15px 12px;
  align-items: center;
  width: 44px;
  flex: 0 0 44px;
  border-right: 0.5px solid $colorN30;
}

.psvto-c1--body {
  display: flex;
  width: 44px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  flex: 0 0 44px;
  border-right: 0.5px solid $colorN30;
}

.psvto-c2--head {
  display: flex;
  width: 140px;
  height: 50px;
  padding: 14px 8px 14px 12px;
  align-items: center;
  flex: 0 0 140px;
}

.psvto-c2--body {
  display: flex;
  width: 140px;
  padding: 16px 12px;
  align-items: center;
  align-self: stretch;
  flex: 0 0 140px;
}

.psvto-headCell {
  height: 50px;
  padding: 14px 8px 14px 12px;
  gap: 2px;
  border-right: 0.5px solid $colorN30;
}

.psvto-bodyCell {
  padding: 16px 12px;
  align-items: center;
  align-self: stretch;
  border-right: 0.5px solid $colorN30;
}

.psvto-c3 {
  width: 106px;
  flex: 0 0 106px;
}
.psvto-c4 {
  width: 106px;
  flex: 0 0 106px;
}
.psvto-c5 {
  width: 117px;
  flex: 0 0 117px;
}
.psvto-c6 {
  width: 141px;
  flex: 0 0 141px;
}

.psvto-c7--head {
  width: 154px;
  height: 50px;
  padding: 14px 8px 14px 12px;
  justify-content: space-between;
  align-items: center;
  border-right: 0.5px solid $colorN30;
  flex: 0 0 154px;
}

.psvto-c7-headInner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.psvto-c7--body {
  display: flex;
  width: 154px;
  padding: 16px;
  align-items: center;
  gap: 10px;
  border-right: 0.5px solid $colorN30;
  flex: 0 0 154px;
}

.psvto-c8 {
  width: 154px;
  flex: 0 0 154px;
}

.psvto-c8--body {
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 10px;
  border-right: 0.5px solid $colorN30;
}

.psvto-c9 {
  width: 117px;
  flex: 0 0 117px;
}

.psvto-c9.psvto-headCell {
  padding: 14px 12px;
}

.psvto-c9--body {
  display: flex;
  width: 117px;
  padding: 16px;
  align-items: center;
  gap: 10px;
  border-right: 0.5px solid $colorN30;
}

.psvto-footer {
  display: flex;
  width: 100%;
  padding: 16px 24px 24px 24px;
  justify-content: space-between;
  align-items: center;
}

.psvto-subFooter-container {
  display: flex;
  padding-right: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  &-sub {
    display: flex;
    height: 42px;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    &-left {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
}
</style>
